var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud05(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 313.778,
    height: 217.96,
    viewBox: "0 0 313.778 217.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M53.41 182.587l.057-.002H81.79c13.08 15.513 32.647 25.375 54.527 25.375 21.284 0 40.378-9.336 53.444-24.123 6.148 6.203 14.672 10.047 24.095 10.047 10.04 0 19.06-4.365 25.27-11.3h32.69c23.176 0 41.965-18.786 41.965-41.964 0-23.176-18.79-41.964-41.966-41.964-.907 0-1.806.04-2.698.096-.78-32.312-27.203-58.272-59.705-58.272-8.116 0-15.853 1.626-22.91 4.56C176.978 18.77 151.81 0 122.25 0 84.52 0 53.93 30.59 53.93 68.323c0 2.524.147 5.014.414 7.468-.312-.005-.62-.022-.933-.022C23.91 75.768 0 99.68 0 129.178c0 29.497 23.912 53.41 53.41 53.41z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud05);
export default __webpack_public_path__ + "static/media/cloud-05.5500c9be25e8e95043dff799d8285dac.svg";
export { ForwardRef as ReactComponent };